<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" [ngSwitch]="name">
    <path *ngSwitchCase="'play'" d="M7 5.2v13.6a1 1 0 0 0 1.5.86l11-6.8a1 1 0 0 0 0-1.72l-11-6.8A1 1 0 0 0 7 5.2z" fill="currentColor"></path>
    <path *ngSwitchCase="'pause'" d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z" fill="currentColor"></path>
    <ng-container *ngSwitchCase="'buy'">
        <path d="M3 4h2.2l2.1 10.2a1.5 1.5 0 0 0 1.5 1.2h8.4a1.5 1.5 0 0 0 1.5-1.1L20.5 8H6.1"></path>
        <circle cx="9.5" cy="19.5" r="1.3"></circle><circle cx="17" cy="19.5" r="1.3"></circle>
    </ng-container>
    <path *ngSwitchCase="'subscribe'" d="M4 8l4 3.5L12 5l4 6.5L20 8l-1.6 9.2a1 1 0 0 1-1 .8H6.6a1 1 0 0 1-1-.8z"></path>
    <ng-container *ngSwitchCase="'lock'">
        <rect x="5" y="10.5" width="14" height="10" rx="2.5"></rect><path d="M8.5 10.5V7.8a3.5 3.5 0 0 1 7 0v2.7"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'clock'">
        <circle cx="12" cy="12" r="8.5"></circle><path d="M12 7.5V12l3 2"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'like'">
        <path d="M7.5 10.5v9H5a1.5 1.5 0 0 1-1.5-1.5v-6A1.5 1.5 0 0 1 5 10.5z" [attr.fill]="filled ? 'currentColor' : 'none'"></path>
        <path d="M7.5 10.5l3.6-6.3a1.6 1.6 0 0 1 2.9 1.2l-.8 3.9h5.2a2 2 0 0 1 2 2.3l-1.1 6.2a2 2 0 0 1-2 1.7H7.5" [attr.fill]="filled ? 'currentColor' : 'none'"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'share'">
        <path d="M12 15V4"></path><path d="M8 7.5L12 3.5l4 4"></path><path d="M6.5 11H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'playlist'">
        <path d="M4 6.5h11M4 11.5h11M4 16.5h6"></path><path d="M18 13.5v7M14.5 17h7"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'report'">
        <path d="M5.5 21V4"></path><path d="M5.5 4.5h10.2a.8.8 0 0 1 .6 1.3L14 9l2.3 3.2a.8.8 0 0 1-.6 1.3H5.5"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'tip'">
        <rect x="3.5" y="8.5" width="17" height="4" rx="1.2"></rect><path d="M5 12.5v6.5a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5v-6.5M12 8.5v12"></path>
        <path d="M12 8.5C10.8 5 7.5 4.6 7.5 6.6c0 1.6 2.8 1.9 4.5 1.9 1.7 0 4.5-.3 4.5-1.9 0-2-3.3-1.6-4.5 1.9z"></path>
    </ng-container>
    <path *ngSwitchCase="'donate'" d="M12 20s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.2a4.3 4.3 0 0 1 7.5 2.6C19.5 15.4 12 20 12 20z"></path>
    <path *ngSwitchCase="'polls'" d="M5 20V12M12 20V5M19 20v-5"></path>
    <path *ngSwitchCase="'back'" d="M14.5 5.5L8 12l6.5 6.5"></path>
    <ng-container *ngSwitchCase="'external'">
        <path d="M14 4h6v6M20 4l-8.5 8.5"></path><path d="M18 14v4.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 4 18.5v-11A1.5 1.5 0 0 1 5.5 6H10"></path>
    </ng-container>
    <path *ngSwitchCase="'edit'" d="M4.5 19.5l1-4L15.8 5.2a2 2 0 0 1 2.8 0l.2.2a2 2 0 0 1 0 2.8L8.5 18.5zM13.5 7.5l3 3"></path>
    <ng-container *ngSwitchCase="'delete'">
        <path d="M4.5 7h15M9.5 7V5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2"></path><path d="M6.5 7l.8 12a1.5 1.5 0 0 0 1.5 1.4h6.4a1.5 1.5 0 0 0 1.5-1.4l.8-12M10 11v6M14 11v6"></path>
    </ng-container>
    <g *ngSwitchCase="'more'" fill="currentColor" stroke="none"><circle cx="5.5" cy="12" r="1.8"></circle><circle cx="12" cy="12" r="1.8"></circle><circle cx="18.5" cy="12" r="1.8"></circle></g>
    <path *ngSwitchCase="'send'" d="M4.5 12L20 4.5 15.5 20l-3-6.5zM12.5 13.5L20 4.5"></path>
</svg>
